import React, { useEffect, useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { ReactComponent as DashboardLogo } from "../../../src/assets/SideBarIcons/Dashboard.svg";
import { ReactComponent as ProduzioneLogo } from "../../../src/assets/SideBarIcons/Produzione.svg";
import { ReactComponent as Structure } from "../../../src/assets/dashboardIcons/structure.svg";
import { ReactComponent as LogisticaIcon } from "../../../src/assets/dashboardIcons/LogisticaIcon.svg";
import "../../stylesheet/Global.css";
import LogoIcon from "../../../src/assets/Logo/Logo_Vivon.png";
import LogoText from "../../../src/assets/Logo/Vivon_Logo_Icon.png";
import { ExpandMore } from "@mui/icons-material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useLocation, useNavigate } from "react-router-dom";
const drawerWidth = 284;
const collapsedDrawerWidth = 80;
const StyledDrawer = styled(Drawer)(({ theme, open }) => ({
  width: open ? drawerWidth : collapsedDrawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  "& .MuiDrawer-paper": {
    width: open ? drawerWidth : collapsedDrawerWidth,
    overflowX: "hidden",
    backgroundColor: "#0D3972",
    color: "#fff",
    transition: "all 0.8s",
  },
}));
const StyledListItem = styled(ListItem)(
  ({ theme, active, open, textColor }) => ({
    padding: theme.spacing(open ? 1 : 2, 2),
    color: active ? textColor : "#fff",
    justifyContent: open ? "initial" : "center",
    "&:hover": {
      color: textColor,
      cursor: "pointer",
      "& .MuiListItemIcon-root": {
        color: textColor,
      },
    },
    "& .MuiListItemIcon-root": {
      "& svg": {
        " & path": {
          fill: active ? "#57C700" : "#fff",
        }
      },
    },

  })
);
const StyledListItemIcon = styled(ListItemIcon)(({ active, color }) => ({

  minWidth: 36,
  color: active ? "" : "#225CA6",
  justifyContent: "center",
  "& .MuiSvgIcon-root": {
    background: color,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));
const menuItems = [
  {
    name: "Ovoland",
    icon: DashboardLogo,
    textColor: "#fff",
    route: "/dashboard",
  },
  {
    name: "Strutture",
    icon: Structure,
    textColor: "#fff",
    route: "/strutture",
    subitems: [
      { name: "Cantine", route: "/strutture/cantine" },
      { name: "Terreni", route: "/strutture/terreni" },
      { name: "Stabilimenti", route: "/strutture/stabilimenti" },
      { name: "Prodotti", route: "/strutture/prodotti" },
      { name: "Sensori", route: "/strutture/sensori" },
      { name: "Operatori", route: "/strutture/operatori" },
    ],
  },

  {
    name: "Produzione",
    icon: ProduzioneLogo,
    textColor: "#fff",
    route: "/strutture",
    subitems: [
      { name: "Produzioni", route: "/produzione/produzioni" },
      { name: "Ricette", route: "/produzione/ricette/Fasi" },
      { name: "Trattamenti", route: "/produzione/trattamenti" },
      { name: "Archivio", route: "/produzione/archivio" },
    ],
  },

  {
    name: "Logistica",
    icon: LogisticaIcon,
    textColor: "#fff",
    route: "/strutture",
    subitems: [
      { name: "Stabilimenti", route: "/logistica/stabilimenti" },
      { name: "Trasporto", route: "/logistica/trasporto" },
      { name: "Mezzi", route: "/logistica/mezzi" },
    ],
  },
  {
    name: "Assistenti",
    icon: ProduzioneLogo,
    textColor: "#fff",
    route: "/strutture",
    subitems: [
      { name: "Enologo", link: "https://relatioai.com/login" },
      { name: "Cantiniere", link: "https://relatioai.com/login" },
      { name: "Agronomo", link: "https://relatioai.com/login" },
      { name: "Meteorologo", link: "https://relatioai.com/login" },
    ],
  },

  // {
  //   name: "Anagrafiche",
  //   icon: AnagraficheLogo,
  //   textColor: "#fff",
  //   route: "/anagrafiche",
  //   subitems: [
  //     { name: "Prodotti", route: "/angrafiche/prodotti" },
  //     { name: "Attrezzature", route: "/angrafiche/attrezzature" },
  //     { name: "Mezzi", route: "/angrafiche/mezzi" },
  //     { name: "Sensori", route: "/angrafiche/sensori" },
  //     { name: "Stabilimenti", route: "/angrafiche/stabilimenti" },
  //     { name: "Lotti", route: "/angrafiche/lotti" },
  //     { name: "Collaboratori", route: "/angrafiche/colaboratory" },
  //     { name: "Fornitori", route: "/angrafiche/fornitori" },
  //     { name: "Clienti", route: "/angrafiche/clienti" },
  //   ],
  // },
];
const Sidebar = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState("");
  const [activeItem, setActiveItem] = useState("Dashboard");
  const navigate = useNavigate();
  const handleSubmenuClick = (name) => {
    setOpenSubmenu(openSubmenu === name ? "" : name);
  };
  // useEffect(() => {
  //   localStorage.removeItem("cantine_id");
  // },[]);
  // Initialize navigate
  const handleSubmenuItemClick = (route, link) => {
    if (link) {
      window.location.href = link;
    } else {
      navigate(route);
    }
    localStorage.removeItem("cantine_id");
    localStorage.removeItem("terreni_id");
    localStorage.removeItem("product_id");
    localStorage.removeItem("stabili_id");
    localStorage.removeItem("mezzi_id");
  };
  useEffect(() => {
    const activeMenuItem = menuItems.find(
      (item) =>
        item.route === location.pathname ||
        (item.subitems && item.subitems.some((sub) => sub.route === location.pathname))
    );

    if (activeMenuItem) {
      setActiveItem(activeMenuItem.name);
    }
  }, [location]);
  // console.log(activeItem, "activefmdj")
  return (
    <StyledDrawer
      variant="permanent"
      open={open}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      className="sidebarMenu"
    >
      <Box
        className="logo"
        sx={{
          p: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: open ? "flex-start" : "center",
        }}
      >

        <img
          className={` ${!open ? "" : "w-0 opacity-0"
            }`}
          src={LogoText}
          height="33"
          alt="Logo Text"
          width="22px"
        />
        <img
          className={` ${open ? "" : " hidden logo-text"
            }`}
          src={LogoIcon}
          alt="Logo Icon"
          width={"180px"}
        />

      </Box>
      <List>
        {menuItems.map((item) => (
          <React.Fragment key={item.name}>
            <StyledListItem
              button
              onClick={() => {
                setActiveItem(item.name);
                if (item.subitems) handleSubmenuClick(item.name);
                else navigate(item.route); // Navigate to the main item route
              }}
              active={activeItem === item.name}
              open={open}
              textColor={item.textColor}
            >
              <div className="mainMenu">
                <StyledListItemIcon active={activeItem === item.name}>
                  <item.icon />
                </StyledListItemIcon>
                {open && <ListItemText primary={item.name} />}
                {open &&
                  item.subitems &&
                  (openSubmenu === item.name ? (
                    <ExpandMore sx={{ color: item?.textColor }} />
                  ) : (
                    <ChevronLeftIcon sx={{ color: item?.textColor }} />
                  ))}
              </div>
              {item.subitems && open && (
                <Collapse
                  in={openSubmenu === item.name}
                  timeout="auto"
                  unmountOnExit
                >
                  <List component="div" className="submenuItem" disablePadding>
                    {item.subitems.map((subitem) => (
                      <StyledListItem
                        key={subitem.name}
                        button
                        sx={{ pl: 4 }}
                        open={open}
                        onClick={() => handleSubmenuItemClick(subitem.route, subitem.link)}
                      >
                        <ListItemText className="" primary={subitem.name} />
                      </StyledListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </StyledListItem>
          </React.Fragment>
        ))}
      </List>
    </StyledDrawer>
  );
};
export default Sidebar;
